<template>
  <div class="row" style="margin-bottom: 1rem;">
    <folder-element v-for="folder in folders" :folder="folder" :key="folder.id"
      @openGeneralUploadModal="$emit('openGeneralUploadModal', $event)"
    />
  </div>
</template>

<script>
  export default {
    props: ['folders'],
  }
</script>



// WEBPACK FOOTER //
// resources/js/components/FolderRow.vue